import { spacing } from 'app/config/grid';

/**
 * Get the spacing.
 */
export const getSpacing = () => spacing;
